import { PathURL } from 'src/utils/constants/path';
import axios from 'axios';
import * as _ from 'lodash';
import { appStore } from 'src/context/AppStore';
import { refreshToken } from 'src/apis/Authenticates/signin';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '',
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  responseType: 'json'
});

axiosInstance.interceptors.request.use(
  function (config) {
    const store = appStore;
    if (store?.userToken) {
      // eslint-disable-next-line
      // @ts-ignore: Unreachable code error
      config.headers.common['Authorization'] = `Bearer ${store?.userToken}`;
      config.baseURL = process.env.REACT_APP_API_BASE || '';
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (response: any) => response,
//   (error: { response: { status: number } }) => {
//     if (error.response.status === 401) {
//       const store = appStore;
//       store.clearPersistedData();
//       window.location.href = PathURL.signin;
//     }
//   }
// );
axiosInstance.interceptors.response.use(
  res => {
    return res;
  },
  async err => {
    const originalConfig = err.config;
    if(err.response.status === 400){
      const errors=err.response.data
      return  Promise.reject(errors);
    }
    if (originalConfig.url !== PathURL.signin && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        const store = appStore;
        originalConfig._retry = true;

        try {
          const responseRefreshToken = await refreshToken(store.refreshToken);
          const { access_token, expires_in, refresh_token } = responseRefreshToken;
          if (access_token) {
            appStore.updateUserToken(access_token, refresh_token, expires_in);
            originalConfig.defaults.headers.common.Authorization = `Bearer ${access_token}`;
            window.location.reload();
          } else {
            appStore.clearPersistedData();
            window.location.href = PathURL.signin;
          }
          return axiosInstance(originalConfig);
        } catch (_error) {
          await appStore.clearPersistedData();
          window.location.href = PathURL.signin;
          return Promise.reject(_error);
        }
      }
    }
    return Promise.reject(err);
  }
);

export const baseUrl: string | undefined = process.env.REACT_APP_API_BASE;

export default _.clone(axiosInstance);
